import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { Icon } from 'sheets';
import scrollableTo from 'components/ScrollableTo/ScrollableTo';

import styles from './ScrollCTA.css';

class ScrollCTA extends React.Component {
  constructor(props) {
    super(props);
    this.handleScrollToId = props.handleScrollToId.bind(this, props.scrollToId);
  }

  render() {
    const promptClass = classNames(styles[`prompt`], {
      [this.props.secondaryClass]: this.props.secondaryClass,
    });

    return (
      <div className={styles[`container`]}>
        <button
          className={promptClass}
          onClick={this.handleScrollToId}
        >
          <Icon
            className={styles[`arrow-icon`]}
            name="arrow-prompt"
          />
        </button>
      </div>
    );
  }
}

ScrollCTA.propTypes = {
  scrollToId: PropTypes.string.isRequired,
  secondaryClass: PropTypes.string,
};

export default scrollableTo(ScrollCTA, false);
